export default __webpack_public_path__ + "static/202-0889c08e09e73fc3449666567bc039f6.jpg";